const LOCAL_HOSTNAMES = new Set(['localhost', '127.0.0.1', '::1']);

export const isDevMode = (): boolean =>
	import.meta.env.DEV || (typeof window !== 'undefined' && LOCAL_HOSTNAMES.has(window.location.hostname));
